(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["board-options"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const openButton = event.target.closest('[data-board-dialog-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.boardDialogOpen);
      if (dialog) { dialog.classList.add('active'); dialog.querySelector('[data-board-dialog-close]').focus(); }
      return;
    }

    const closeButton = event.target.closest('[data-board-dialog-close]');
    if (closeButton) {
      closeButton.closest('.board-choice-dialog')?.classList.remove('active');
      return;
    }

    const actionButton = event.target.closest('[data-board-add-to-cart], [data-board-buy-now]');
    if (!actionButton) return;

    const section = actionButton.closest('[data-board-choice-section]');
    const quantity = Number(section.querySelector('[name="quantity"]').value);
    const variantId = actionButton.dataset.variantId;
    const message = section.querySelector('[data-board-cart-message]');
    const originalText = actionButton.textContent.trim();

    if (!variantId) {
      message.textContent = 'Please configure the product variant ID in the Theme Editor.';
      return;
    }

    actionButton.disabled = true;
    actionButton.textContent = 'Adding…';
    message.textContent = '';

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] })
      });

      if (!response.ok) throw new Error('Cart request failed');

      if (actionButton.hasAttribute('data-board-buy-now')) {
        window.location.assign('/checkout');
        return;
      }

      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await cartResponse.json();
      document.querySelectorAll('.cart-count').forEach((count) => {
        count.textContent = cart.item_count;
        count.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      message.textContent = 'Added to your basket.';
    } catch (error) {
      message.textContent = 'We could not add this item. Please try again.';
    } finally {
      actionButton.disabled = false;
      actionButton.textContent = originalText;
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.matches('.board-choice-dialog')) event.target.classList.remove('active');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.board-choice-dialog.active').forEach((modal) => modal.classList.remove('active'));
  });

  } catch(e) { console.error(e); }
})();
})();
